import { useLang } from "@/context/LanguageContext";
import { t } from "@/data/translations";
import { Phone, MessageCircle, Send } from "lucide-react";
import { motion } from "framer-motion";

const contactMethods = [
  {
    key: "phone",
    Icon: Phone,
    href: "tel:+420607179165",
    display: "+420 607 179 165",
  },
  {
    key: "whatsapp",
    Icon: MessageCircle,
    href: "https://wa.me/420607179165",
    display: "WhatsApp",
    external: true,
  },
  {
    key: "telegram",
    Icon: Send,
    href: "https://t.me/+420607179165",
    display: "Telegram",
    external: true,
  },
];

export default function Contacts() {
  const { lang } = useLang();
  const ct = t.contacts[lang];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16 md:py-28">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] font-semibold text-[#FF3B30] mb-3 sm:mb-4" data-testid="contacts-overline">
          {lang === "cs" ? "SPOJTE SE S NAMI" : "GET IN TOUCH"}
        </p>
        <h1
          data-testid="contacts-title"
          className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-none text-[#0A0B10] mb-3 sm:mb-4"
        >
          {ct.title}
        </h1>
        <p className="text-sm sm:text-base lg:text-lg text-[#666666] leading-relaxed mb-10 sm:mb-16 max-w-lg" data-testid="contacts-subtitle">
          {ct.subtitle}
        </p>
      </motion.div>

      {/* Big phone number */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="mb-12 sm:mb-20"
      >
        <a
          href="tel:+420607179165"
          data-testid="contacts-phone-big"
          className="font-heading text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold tracking-tighter text-[#0A0B10] hover:text-[#FF3B30] transition-colors break-all sm:break-normal"
        >
          +420 607 179 165
        </a>
      </motion.div>

      {/* Contact methods grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8">
        {contactMethods.map(({ key, Icon, href, display, external }, i) => (
          <motion.a
            key={key}
            href={href}
            target={external ? "_blank" : undefined}
            rel={external ? "noreferrer" : undefined}
            data-testid={`contact-method-${key}`}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
            className="group p-6 sm:p-8 border border-[#E5E5E5] hover:border-[#0A0B10] transition-all hover:scale-[1.02] flex sm:block items-center gap-4"
          >
            <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-[#FF3B30] sm:mb-6 group-hover:scale-110 transition-transform flex-shrink-0" />
            <div>
              <h3 className="font-heading text-base sm:text-lg font-medium text-[#0A0B10] mb-0.5 sm:mb-1">{ct[key]}</h3>
              <p className="text-xs sm:text-sm text-[#666666]">{display}</p>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
}
